import { generateTestId } from "@client-shared";
import type { CatalogueRegionId } from "@shared/types/admin-catalogue";

export const DEFAULT_CATALOGUE_REGION: CatalogueRegionId = "US";

// Region is part of the key so a region switch can never serve another
// region's cached rows.
export const adminProductCatalogueQueryKey = (region: CatalogueRegionId) => ["admin-product-catalogue", region] as const;

export const setAdminProductsPageTestId = (identifier: string): string => generateTestId("AdminProductsPage", identifier);
